export const NOMINATIM_ENDPOINT = "http://localhost:8090"; //"https://nominatim-test.exanio.cloud";

/**
 * Sentinel stored in the `switches` (NetboxSwitches) question value when the
 * "Use customer Switch" toggle is on: no NetBox switch is selected and the
 * switch details are entered manually in the Hardware switch fields instead.
 * Persisting it lets the toggle survive re-renders/regeneration, and the server
 * skips the NetBox lookup for this value.
 */
export const CUSTOMER_SWITCH_VALUE = "customer-switch";
